export const isEqual = (a: unknown, b: unknown) => a === b;
